<script>
	import QrCode from "svelte-qrcode"

	export let name="Welcome";
	export let background="#ffffff";
	export let color="#000";
	export let size="512";
</script>

<main class="flex-shrink-0">
	<!-- Navigation-->
	<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
		<div class="container px-5">
			<a class="navbar-brand" href="/">Free QR Code Generator</a>
			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
			<div class="collapse navbar-collapse" id="navbarSupportedContent">
				<ul class="navbar-nav ms-auto mb-2 mb-lg-0">
					<li class="nav-item"><a class="nav-link" href="/">Home</a></li>
					<li class="nav-item"><a class="nav-link" target="_blank" href="https://github.com/dev-itsarun">Developer</a></li>
				</ul>
			</div>
		</div>
	</nav>
	<!-- Header-->
	<header class="bg-dark py-5">
		<div class="container px-5">
			<div class="row gx-5 align-items-center justify-content-center">
				<div class="col-lg-8 col-xl-7 col-xxl-6">
					<div class="my-5 text-center text-xl-start">
						<h5 class="fw-bolder text-white mb-2">First Set Colors and Size and Change the Text/URL</h5>
						<form class="pt-5">
							<div class="mb-3">
								<label for="textdata" class="form-label text-white">Text / URL</label>
								<input type="text" class="form-control" id="textdata" bind:value={name}>
							</div>
							<div class="mb-3 col-auto">
								<label for="background" class="form-label text-white">Background Color</label>
								<input type="color" class="form-control form-control-color" id="background" bind:value={background}>
							</div>
							<div class="mb-3 col-auto">
								<label for="front" class="form-label text-white">Front Color</label>
								<input type="color" class="form-control form-control-color" id="front" bind:value={color}>
							</div>
							<div class="mb-3">
								<label for="size" class="form-label text-white">size in pixels</label>
								<input type="text" class="form-control" id="size" bind:value={size}>
							</div>
						</form>
					</div>
				</div>
				<div class="col-xl-5 col-xxl-6 text-center">
					<div class="img-fluid qrcode">
						<QrCode 
						value="{name}"
						background="{background}"
						color="{color}"
						size="{size}"
						padding = "10"/>
					</div>
				</div>
			</div>
			<div class="row gx-5 align-items-center justify-content-center pt-5">
				<div class="col-lg-12 col-xl-12 col-xxl-12">
					<h5 class="text-white text-center"> QR will be Automatically Re-generated When you change the Data</h5>
				</div>
			</div>
		</div>
	</header>

	<!-- Blog preview section-->
	<section class="py-5">
		<div class="container px-5 my-5">
			<!-- Call to action-->
			<aside class="bg-primary bg-gradient rounded-3 p-4 p-sm-5 mt-5">
				<div class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
					<div class="mb-4 mb-xl-0">
						<div class="fs-3 fw-bold text-white">Site Powered By <b>Cloudflare</b></div>
					</div>
				</div>
			</aside>
		</div>
	</section>
</main>
<!-- Footer-->
<footer class="bg-dark py-4 mt-auto">
	<div class="container px-5">
		<div class="row align-items-center justify-content-between flex-column flex-sm-row">
			<div class="col-auto"><div class="small m-0 text-white">Copyright &copy; Free QR Code Generator</div></div>
		</div>
	</div>
</footer>